<template>
  <router-view />
</template>

<script>
export default {
  data() {
    return {
      titleBase:
        "有料サービスお申込みフォーム｜児童見守り安心システム　ツイタもん",
    };
  },
  methods: {
    setTitle: function (routeInstance) {
      if (routeInstance.meta.title) {
        document.title = routeInstance.meta.title + "｜" + this.titleBase;
      } else {
        document.title = this.titleBase;
      }
    },
  },
  mounted: function () {
    var routeInstance = this.$route;
    this.setTitle(routeInstance);
  },
  watch: {
    $route(routeInstance /*, from*/) {
      this.setTitle(routeInstance);
    },
  },
};
</script>

<style lang="scss"></style>
